import ContactService from '../ContactService';
import PresenceSocketService from '../PresenceSocketService';
import DataService from '../DataService';

let isAdmin = false;

export const AdminService = {

    isAdmin: () => isAdmin,

    setIsAdmin: (value = false) => { isAdmin = value },

    checkSecretToUuidMap: () => {
        const data = PresenceSocketService.channel().members;
        return !!Object.keys(data.members).filter(secret => {
            const isOrganiser = (data.members[secret].is_admin || data.members[secret].is_host);
            return !isOrganiser && !ContactService.getContactUuid(secret);
        }).length;
    },

    updateSecretToUuidMap: () => {
        if (AdminService.checkSecretToUuidMap()) {
            return DataService.get().then(data => {
                // Update secret to contact uuid map
                ContactService.setSecretToUuidMap(data.secret_to_uuid_map);
            });
        }
    }

};

export default AdminService;